const locale = {
	active:'有効',
	inactive:'無効',
	deleted: '削除',
	filter:'絞り込み',
	filter_by:'絞り込み条件:',
	reset_filters:'リセット',
	project_name: '現場名',
	project_branch:'支店',
	project_type:'区分',
	country:'国',
	prefecture:'都道府県',
	linked_members:'関連ユーザー',
	status:'ステータス',
	actions:'オプション',
	add_project: '現場登録・編集',
	companies: '企業',
	projects:'現場',
	back_to_projects_list:' 現場一覧へ戻る',
	all_projects: '現場',
	edit_projects: '現場を編集',
	search_project: '現場を検索',
	search_member: 'ユーザー名で検索',
	create_project: '現場を作成',
	edit_project: '現場を編集',
	remove_project:'現場を削除',
	remove:'削除',
	recover_project:'現場を復帰',
	view_members:'ユーザーリスト',
	do_you_want_to_remove_this_member:'このユーザーを削除しますか？',
	zip_code:'郵便番号',
	city:'市',
	town:'町村',
	latitude:'緯度',
	longitude: '経度',
	upload_map:'地図画像をアップロード',
	address: 'その他住所',
	drag_n_drop_some_files_here_or_click_to_select_files:'ファイルをドロップ、もしくはクリックして選択してください',
	please_enter_valid_url:'有効なURLを入力してください',
	please_enter_valid_label:'ラベルは15文字以下で入力してください',
	this_project_name_already_exist:'この現場名は既に存在します',
	single_byte_numbers_no_hyphen:'半角数字のみ。ハイフン(-)不要',
	please_enter_only_single_byte_numbers:'半角数字を入力してください',
	do_you_want_to_remove_this_project: 'この現場を削除しますか？',
	do_you_want_to_recover_this_project: 'この現場を復帰しますか？',
	invalid_address_please_try_again: '形式が無効です。再入力してください',
	created_succesfully:'作成完了',
	updated_succesfully: '更新完了',
	project_code: '現場コード',
	only_alphanumeric_allowed:'英数字のみ',
	please_enter_a_valid_project_code: '有効な現場コードを入力してください',
	loading: '読み込み中...',
	search : '検索',

	current_project: '現在の現場:',
	mapping_member: '関連ユーザー',
	search_for_email: 'メールアドレスで検索',
	Submit:'登録',
	Cancel:'キャンセル',
	Update:'更新',

	project_information: '現場情報',
	url_links: '関連URL',
	face_camera:'切羽カメラ URL',
};

export default locale;
